import { useState, useCallback } from 'react'
import { Box, Button, Modal, Slider, Typography, useMediaQuery } from '@mui/material'
import Cropper from 'react-easy-crop'
import getCroppedImg from '../../../../utils/cropImage'

export function CropModal({ open, imageSrc, onClose, onCropComplete }) {
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const isMobile = useMediaQuery('(max-width:1050px)')

    const handleCropComplete = useCallback((_, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const handleConfirm = async () => {
        if (!croppedAreaPixels) return
        const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels)
        setCrop({ x: 0, y: 0 })
        setZoom(1)
        onCropComplete(croppedBlob)
    }

    const handleClose = () => {
        setCrop({ x: 0, y: 0 })
        setZoom(1)
        onClose()
    }

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: isMobile ? 320 : 500,
                bgcolor: 'background.paper',
                borderRadius: '30px',
                boxShadow: 24,
                p: 4,
            }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Crop Profile Picture
                </Typography>

                <Box sx={{ position: 'relative', width: '100%', height: 300 }}>
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={1}
                        cropShape="round"
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={handleCropComplete}
                    />
                </Box>

                <Typography variant="body2" sx={{ mt: 2, mb: 1, color: 'text.secondary' }}>
                    Zoom
                </Typography>
                <Slider
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    onChange={(_, value) => setZoom(value)}
                    size="small"
                />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        sx={{ borderRadius: '40px', textTransform: 'none' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        variant="contained"
                        sx={{ borderRadius: '40px', textTransform: 'none' }}
                    >
                        Crop & Upload
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}
